import {useAuth} from "./auth/AuthContext";
import UserProvider from "./content/user/UserProvider";
import {useUser, useUserRoles} from "./content/user/UserContext";
import {BrowserRouter} from "react-router-dom";
import AppRoutes from "./AppRoutes";
import * as React from "react";

export default function AppBody() {
    const { authClient, initialized} = useAuth();

    if (!initialized || !authClient?.authenticated) {
        return null;
    }

    return (
        <UserProvider>
            <Router />
        </UserProvider>
    );
}

function Router() {
    const user = useUser();
    const roles = useUserRoles();
    if (!user || !roles || roles.length === 0) {
        return null;
    }

    return (
        <BrowserRouter basename={process.env.PUBLIC_URL}>
            <AppRoutes userRoles={roles} />
        </BrowserRouter>
    );
}